import { create } from 'zustand';
import type { ShiftBarActions } from '@/components/pos/ShiftBarActionsContext';

type ShiftBarActionsState = {
  actions: ShiftBarActions | null;
  setActions: (actions: ShiftBarActions | null) => void;
};

export const useShiftBarActionsStore = create<ShiftBarActionsState>((set) => ({
  actions: null,
  setActions: (actions) => set({ actions }),
}));
